import PptxGenJS from "pptxgenjs";
import { TEXT_OPTIONS } from "./templates/rra/masters/components";

type UnderlineStyle =
  | "dash"
  | "dashHeavy"
  | "dashLong"
  | "dashLongHeavy"
  | "dbl"
  | "dotDash"
  | "dotDashHeave"
  | "dotDotDash"
  | "dotDotDashHeavy"
  | "dotted"
  | "dottedHeavy"
  | "heavy"
  | "none"
  | "sng"
  | "sngHeavy"
  | "wavy"
  | "wavyDbl"
  | "wavyHeavy"
  | "words";

export const parseMarkdownToPptxText = (markdown: string): any[] => {
  const lines = markdown.split("\n");
  const textArray: any[] = [];

  for (const line of lines) {
    if (line.trim() === "") continue;

    // Handle bullet points
    if (line.trim().startsWith("- ")) {
      textArray.push({
        text: line.trim().substring(2),
        options: {
          ...TEXT_OPTIONS.body,
          bullet: {
            code: "2022",
            indent: 12,
          },
        },
      });
      continue;
    }

    // Handle bold text
    let text = line;
    const boldMatches = text.match(/\*\*(.*?)\*\*/g);
    if (boldMatches) {
      for (const match of boldMatches) {
        const content = match.slice(2, -2);
        text = text.replace(match, content);
        textArray.push({
          text: content,
          options: { ...TEXT_OPTIONS.body, bold: true },
        });
      }
    }

    // Handle italic text
    const italicMatches = text.match(/\*(.*?)\*/g);
    if (italicMatches) {
      for (const match of italicMatches) {
        const content = match.slice(1, -1);
        text = text.replace(match, content);
        textArray.push({
          text: content,
          options: { ...TEXT_OPTIONS.body, italic: true },
        });
      }
    }

    // Handle underline text
    const underlineMatches = text.match(/__(.*?)__/g);
    if (underlineMatches) {
      for (const match of underlineMatches) {
        const content = match.slice(2, -2);
        text = text.replace(match, content);
        textArray.push({
          text: content,
          options: {
            ...TEXT_OPTIONS.body,
            underline: {
              style: "sng" as UnderlineStyle,
            },
          },
        });
      }
    }

    // Add any remaining text
    if (text.trim()) {
      textArray.push({
        text,
        options: { ...TEXT_OPTIONS.body },
      });
    }
  }

  return textArray;
};
